module.exports = __webpack_public_path__ + "static/media/cloth.baae447c.jpeg";